// extracted by mini-css-extract-plugin
export default {"header":"GroupsView-module__header--p-ZPx","emptyStateContainer":"GroupsView-module__emptyStateContainer--FcnKh","groupCards":"GroupsView-module__groupCards--I9wxu"};